export default __webpack_public_path__ + "static/media/benefit_1.8d3db900.png";